<template>
  <div>
    <stripe-elements
      ref="stripeElements"
      :billing-details="billingDetails"
      mode="setup"
      :render-form-on-mount="setupIntentClientSecret == null"
      :currency="currency"
      :public-key="publicKey"
      :wallets="wallets"
      v-on="$listeners"
      @stripe:ready="onStripeReady"
    ></stripe-elements>
  </div>
</template>

<script>
import StripeElements from './StripeElements.vue';

export default {
  components: { StripeElements },
  props: {
    publicKey: {
      type: String,
      required: true,
    },
    currency: {
      type: String,
      required: true,
    },
    clientSecret: {
      type: String,
      required: true,
    },
    setupIntentClientSecret: {
      type: String,
      default: null,
    },
    customerEmail: {
      type: String,
      default: null,
    },
    customerCountry: {
      type: String,
      default: null,
    },
    wallets: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {
    billingDetails() {
      return {
        address: {
          country: this.customerCountry,
        },
      };
    },
  },
  methods: {
    async confirmSetup() {
      const paymentOptions = {
        clientSecret: this.clientSecret,
        confirmParams: {
          return_url: window.location.href,
          expand: ['payment_method'],
        },
        redirect: 'always', // 'if_required',
      };
      // stripe.confirmSetup() will redirect the user to a different page
      await this.$refs.stripeElements.confirmSetup(paymentOptions);
    },
    onStripeReady() {
      if (this.setupIntentClientSecret) {
        this.$refs.stripeElements.getSetupIntent(this.setupIntentClientSecret);
      }
    },
  },
};
</script>
